import Logo from "../../assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../auth/authService";

export default function Header({
    sellTickets = false,
    hasOffCanvasControl = false,
    onOffCanvasOpen,
    username,
}) {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
            navigate("/");
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

    return (
        <header className="relative flex items-center justify-between mx-6 my-4 lg:mx-20">
            <div className="relative flex items-center gap-3">
                {hasOffCanvasControl && (
                    <button
                        type="button"
                        onClick={onOffCanvasOpen}
                        aria-label="Open menu"
                        className="flex h-10 w-10 text-2xl items-center justify-center rounded-sm transition md:absolute md:right-full md:mr-3 md:top-1/2 md:-translate-y-1/2"
                    >
                        ☰
                    </button>
                )}

                <Link to="/" className="flex items-end">
                    <img
                        src={Logo}
                        alt=""
                        aria-hidden="true"
                        className="h-14 w-14 object-contain"
                    />

                    <span className="text-2xl font-bold italic tracking-tight">
                        Tickets.NP
                    </span>
                </Link>
            </div>

            <div className="flex items-center gap-3">
                {username && (
                    <span className="text-sm font-medium text-gray-700">
                        {username}
                    </span>
                )}

                {username && (
                    <button
                        type="button"
                        onClick={handleLogout}
                        className="rounded-sm border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-100"
                    >
                        Logout
                    </button>
                )}

                {sellTickets && (
                    <a
                        href="https://npsolved.com/contact"
                        className="rounded-sm bg-black p-2 text-sm text-white hover:opacity-75"
                    >
                        Sell Tickets
                    </a>
                )}
            </div>
        </header>
    );
}